import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, Container, Button, Dropdown } from 'semantic-ui-react';
import { useAuth } from '../../contexts/AuthContext';

function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  // Debug logs
  console.log('NavBar user:', user);
  console.log('User roles:', user?.roles);
  console.log('Is admin?', user?.roles?.some(role => role.name === 'admin'));

  return (
    <Menu fixed="top" inverted>
      <Container>
        <Menu.Item as={Link} to="/" header>
          Miakara Soap Recipes
        </Menu.Item>
        
        <Menu.Item as={Link} to="/recipes">
          Recipes
        </Menu.Item>
        
        <Menu.Item as={Link} to="/oils">
          Oils
        </Menu.Item>
        
        {user && (
          <Menu.Item as={Link} to="/additives">
            Additives
          </Menu.Item>
        )}
        
        <Menu.Item as={Link} to="/calculator">
          Calculator
        </Menu.Item>
        
        {user?.roles?.some(role => role.name === 'admin') && (
          <Dropdown item text="Admin">
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/admin/users">
                Users
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/admin/oils">
                Oils
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
        
        <Menu.Menu position="right">
          {user ? (
            <>
              <Menu.Item>
                Welcome, {user.name}
              </Menu.Item>
              <Menu.Item as={Link} to="/settings">
                Settings
              </Menu.Item>
              <Menu.Item>
                <Button onClick={handleLogout} color="red">
                  Logout
                </Button>
              </Menu.Item>
            </>
          ) : (
            <Menu.Item as={Link} to="/auth">
              Sign In
            </Menu.Item>
          )}
        </Menu.Menu>
      </Container>
    </Menu>
  );
}

export default NavBar; 